<template>
  <a-modal
    title="数据导出"
    :visible="visible"
    :mask-closable="false"
    :width="460"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <div class="a-import">
      <a-row :gutter="16">
        <a-col :span="8">
          <span>
            <a-radio-group
              :options="importOptions"
              default-value="0"
              @change="onChange($event)"
            /></span>
        </a-col>
      </a-row>
      <a-range-picker
        v-if="isMonthVisible"
        :value="form.time"
        :placeholder="['开始月份', '结束月份']"
        format="YYYY-MM"
        :mode="rangePickerMode"
        @panelChange="panelChange"
        @change="monthChange"
      />
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ExportTables',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    importOptions: {
      type: Array,
      default: function () { return [{ label: '按年数据导出', value: '0' }, { label: '按月数据导出', value: '1' }] }
    },
    isMonth: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      // importOptions: [{ label: '按年数据导出', value: '0' }, { label: '按月数据导出', value: '1' }],
      subRecord: false,
      form: {
        yearMonthStart: null,
        yearMonthEnd: null,
        time: []
      },
      rangePickerMode: ['month', 'month'],
      isMonthVisible: false
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        this.subRecord = false
        this.isMonthVisible = false
        this.form.time = []
      }
    }
  },
  methods: {
    handleCancel () {
      this.isMonthVisible = false
      this.$emit('cancel')
    },
    handleOk () {
      // this.isMonthVisible = false
      this.$emit('exportOk', this.subRecord)
    },
    onChange (e) {
      if (e.target.value === '0' && this.isMonth) {
        this.subRecord = false
        this.isMonthVisible = false
      } else if (e.target.value !== '0' && this.isMonth) {
        this.subRecord = true
        this.isMonthVisible = true
      } else if (e.target.value === '1' && !this.isMonth) {
        this.subRecord = true
      } else if (e.target.value === '2' && !this.isMonth) {
        this.subRecord = false
      }
    },
    panelChange (value) {
      this.form.yearMonthStart = value[0].format('YYYY-MM')
      this.form.yearMonthEnd = value[1].format('YYYY-MM')
      this.form.time = [this.form.yearMonthStart, this.form.yearMonthEnd]
      this.$emit('monSelected', this.form.time)
    },
    monthChange (value) {
      if (value.length === 0) {
        this.form.yearMonthStart = null
        this.form.yearMonthEnd = null
        this.form.time = value
      }
    }
  }
}
</script>
<style lang="less" scoped>
.a-import {
  /deep/.ant-row {
    margin: 20px;
  }
}
</style>
